export default __webpack_public_path__ + "static/media/misc-drawerB-768w.531d716e.png";